import React, {useContext} from 'react';
import {getAuthToken} from '../auth';
import {LayoutContext} from '../context';
import {getHomePathForRole} from '../roles';
import HomeMediaFolder from './Folder';
export default function StaffHomeMediaFolder() {
  const {account, effectiveRole} = useContext(LayoutContext);
  const canBrowse = account?.role === 'administrator' || (account?.permissions || []).includes('storage.view');
  return <HomeMediaFolder audience="staff" getToken={getAuthToken}
    backPath={canBrowse ? '/storage' : getHomePathForRole(effectiveRole)} />;
}
